var createResponseHandler = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.withHeaders, withHeaders = _c === void 0 ? false : _c;
    return function (response) { return function () {
        if (response.status < 300) {
            return withHeaders
                ? Promise.resolve({
                    body: response.body,
                    headers: new Headers(response.headers),
                })
                : Promise.resolve(response.body);
        }
        return Promise.reject(response);
    }; };
};
export var handleAggregatorResponse = createResponseHandler({
    withHeaders: false,
});
export var handleAggregatorResponseWithHeaders = createResponseHandler({
    withHeaders: true,
});
